import { parseProductCode } from '@webdev/product-code';
import { LicenseRatePlan } from './makeLicenseCapacities';

export function isUniversityRatePlan(ratePlan: Pick<LicenseRatePlan, 'ProductCode__c'>) {
  const { ProductCode__c } = ratePlan;
  if (!ProductCode__c) {
    return false;
  }
  const { productSubType } = parseProductCode(ProductCode__c);
  return productSubType === 'U';
}
